// AB 批次匯入(S29)+ AA 池水位/異常(S30)API layer。後端 = ca-manager,經
// restful 白名單代理 /v3/admin/{imports,stock,anomalies}*。匯入為 multipart 上傳
// (apiFetch 只送 JSON,故手動 fetch;帶 token + client headers)。
import { apiFetch, tokenStore, ApiError } from '../../lib/api';
import { config } from '../../config';

export interface ImportBatch {
  import_id: string;
  type: string;
  source?: string | null;
  submitted: number;
  inserted: number;
  skipped: number;
  failed: number;
  operator?: string | null;
  created_at?: string | null;
}

/** POST /v3/admin/imports — multipart NDJSON 上傳(同步入池)。 */
export async function importCerts(file: File, source: string): Promise<ImportBatch> {
  const fd = new FormData();
  fd.append('file', file);
  if (source.trim()) fd.append('source', source.trim());
  const headers: Record<string, string> = {
    'X-Client-Id': config.clientId,
    'X-Client-Key': config.clientKey,
  };
  const token = tokenStore.get();
  if (token) headers['Authorization'] = 'Bearer ' + token;

  const res = await fetch(`${config.apiBase}/v3/admin/imports`, { method: 'POST', headers, body: fd });
  const body = (await res.json().catch(() => ({}))) as { data?: ImportBatch; error?: { code?: string; message?: string } };
  const requestId = res.headers.get('X-Request-Id');
  if (!res.ok) {
    throw new ApiError(res.status, body.error?.code ?? `HTTP_${res.status}`, body.error?.message ?? `HTTP ${res.status}`, requestId);
  }
  return body.data as ImportBatch;
}

export interface ImportPage {
  items: ImportBatch[];
  nextCursor: string | null;
}
export async function listImports(cursor?: string): Promise<ImportPage> {
  const res = await apiFetch<{ items?: ImportBatch[]; next_cursor?: string }>('/v3/admin/imports', { query: { cursor } });
  return {
    items: Array.isArray(res.data?.items) ? res.data.items : [],
    nextCursor: res.data?.next_cursor && res.data.next_cursor !== '' ? res.data.next_cursor : null,
  };
}

export interface TypeStock {
  type: string;
  available: number;
  allocated: number;
  paired: number;
}
export async function getStock(): Promise<TypeStock[]> {
  const res = await apiFetch<{ items?: TypeStock[] }>('/v3/admin/stock');
  return Array.isArray(res.data?.items) ? res.data.items : [];
}

export interface Anomaly {
  kind: string;
  did?: string;
  detail?: string;
}
export async function getAnomalies(): Promise<Anomaly[]> {
  const res = await apiFetch<{ items?: Anomaly[] }>('/v3/admin/anomalies');
  return Array.isArray(res.data?.items) ? res.data.items : [];
}
